import * as Types from "./types";
export const productAddAction = (value) => {
  return {
    type: Types.PRODUCT_ADD,
    payload: value,
  };
};
export const productDecrementAction = (value) => {
  return {
    type: Types.PRODUCT_DECREMENT,
    payload: value,
  };
};
